import { ReactNode, Ref } from "react";
import cx from "classnames";

import Box from "ds/components/Box";

import styles from "./styles.module.css";

type BillingUpgradeOptionsCarouselProps = {
  trackRef: Ref<HTMLDivElement>;
  onScroll: () => void;
  atStart: boolean;
  atEnd: boolean;
  children: ReactNode;
};

const BillingUpgradeOptionsCarousel = ({
  trackRef,
  onScroll,
  atStart,
  atEnd,
  children,
}: BillingUpgradeOptionsCarouselProps) => {
  return (
    <Box
      fullWidth
      className={cx(styles.viewport, !atStart && styles.fadeStart, !atEnd && styles.fadeEnd)}
    >
      <Box ref={trackRef} gap="large" fullWidth className={styles.track} onScroll={onScroll}>
        {children}
      </Box>
    </Box>
  );
};

export default BillingUpgradeOptionsCarousel;
